import React from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { ArrowLeft } from 'lucide-react';
import PortalLayout from '@/components/portal/PortalLayout';
import { ConversationDetailContent } from '@/components/builder/ConversationDetailContent';

const PortalConversationDetail: React.FC = () => {
  const { conversationId } = useParams<{ conversationId: string }>();
  const navigate = useNavigate();

  const handleBackToConversations = () => {
    navigate('/portal/conversations');
  };

  return (
    <PortalLayout>
      <div className="space-y-6">
        <div className="flex items-center justify-between">
          <div className="flex items-center gap-4">
            <Button
              variant="outline"
              size="sm"
              onClick={handleBackToConversations}
            >
              <ArrowLeft className="h-4 w-4 mr-2" />
              Back to Conversations
            </Button>
            <div>
              <h1 className="text-2xl font-bold">Conversation Details</h1>
            </div>
          </div>
        </div>

        <ConversationDetailContent
          conversationId={conversationId || null}
          onExternalActions={{
            // Page doesn't need external actions
          }}
        />
      </div>
    </PortalLayout>
  );
};

export default PortalConversationDetail;
